import { Helmet } from "react-helmet";

export default function SectionThree({ openModal }: any) {
  return (
    <div className="w-full relative overflow-hidden font-aldrich">
       <Helmet>
        <title>Discover Digital Growth | Student Acquisition Program</title>
        <meta name="description" content="Find out how you can grow your student acquisition with our digital audit." />
        <meta name="keywords" content="student acquisition, digital marketing, online growth" />
        <meta property="og:title" content="Student Acquisition Program" />
        <meta property="og:description" content="Get a digital audit and discover ways to improve student enrollment." />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="max-w-2xl md:max-w-full lg:mx-[2rem]  px-2 py-4 flex flex-col space-y-6 bg-gray-50 ">
        <div className="w-full flex items-center justify-end">
          <button
            onClick={openModal}
            className="bg-red-600 text-white m-0 py-2 px-12 md:px-14 text-base md:text-lg lg:text-xl xl:text-3xl transform transition-transform duration-300 hover:scale-105 active:scale-95 hover:bg-red-700 whitespace-nowrap"
          >
            Discover how
          </button>

          <span className="bg-red-600 h-[2px] w-full md:w-[40%]"></span>
        </div>

        {/* Right Content */}
        <div className="flex justify-center md:justify-end">
          <iframe
            className="w-full max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-[110rem] 2xl:max-w-[140rem] h-60 sm:h-80 md:h-96 lg:h-[500px] xl:h-[650px] 2xl:h-[750px]"
            src="https://www.youtube.com/embed/AALDAz93-eg?si=WqgtMsQJmygdVoYw"
            title="YouTube video player"
            frameBorder="10"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
        <div className="w-full flex items-center justify-end">
          <button
            onClick={openModal}
            className="bg-red-600 text-white m-0 py-2 px-4 sm:px-6 text-base md:text-lg lg:text-xl xl:text-3xl transform transition-transform duration-300 hover:scale-105 active:scale-95 hover:bg-red-700 whitespace-nowrap"
          >
            Get Your Digital Audit
          </button>

          <span className="bg-red-600 h-[2px] w-full md:w-[40%]"></span>
        </div>
      </div>
    </div>
  );
}
